// SPDX-License-Identifier: MIT
export class Address {
    static getName() {
        throw new Error('Address.getName() not implemented');
    }
    static encode(publicKey, options) {
        throw new Error('Address.encode() not implemented');
    }
    static decode(address, options) {
        throw new Error('Address.decode() not implemented');
    }
}
//# sourceMappingURL=address.js.map